<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h2>UPDATE TICKET EVENT USSD</h2>
      </div>

      <div class="form-modal-body" v-if="selected_event">
        <b-field label="Ticket Event">
          <b-input :value="selected_event.title" readonly expanded></b-input>
        </b-field>

        <div class="row">
          <b-field label="Current USSD Code" style="width: 100%">
            <b-input :value="currentUssd" readonly expanded></b-input>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="Current Ticket Event ID" style="width: 100%">
            <b-input :value="String(selected_event.id)" readonly expanded></b-input>
          </b-field>
        </div>

        <b-field label="New Ticket Event ID (USSD Number)">
          <b-input v-model="new_event_id" type="number" min="1" placeholder="Enter new ticket event ID" expanded>
          </b-input>
        </b-field>

        <div class="info-box">
          This applies to ticket events only, not live streaming events.
          The new ID becomes the USSD code <strong>*550*2*2*{new ID}#</strong>.
          Related tickets, pre-sell, invitations, bookings, and ticket transactions will be updated.
        </div>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="loading" @click="submitUpdate()" type="is-primary">UPDATE USSD</b-button>
        <div class="h-spacer"></div>
        <b-button @click="closeModal()" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isModalActive: false,
    selected_event: null,
    new_event_id: "",
    loading: false,
  }),
  computed: {
    currentUssd() {
      if (!this.selected_event) return "";
      if (this.selected_event.customUssd) return this.selected_event.customUssd;
      return `*550*2*2*${this.selected_event.id}#`;
    },
  },
  methods: {
    openModal(event) {
      this.selected_event = event;
      this.new_event_id = "";
      this.isModalActive = true;
    },
    closeModal() {
      this.isModalActive = false;
      this.selected_event = null;
      this.new_event_id = "";
    },
    submitUpdate() {
      let vm = this;
      const newId = parseInt(vm.new_event_id, 10);

      if (!newId || newId <= 0) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Validation",
          text: "Please enter a valid event ID number.",
        });
        return;
      }

      vm.loading = true;
      vm.$store
        .dispatch("EVENTS_UPDATE_USSD_ID", {
          user_id: vm.partner.id,
          event_id: vm.selected_event.id,
          new_event_id: newId,
        })
        .then((response) => {
          vm.loading = false;
          vm.closeModal();
          vm.$emit("success", response.data.return);
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.loading = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: (response && response.data && response.data.message) || "Failed to update USSD ID.",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    h2 {
      font-size: 18px;
      font-weight: 700;
      margin: 0;
    }

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;

    .row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;

      .h-spacer {
        width: 15px;
        flex-shrink: 0;
      }
    }

    .info-box {
      margin-top: 15px;
      padding: 12px 14px;
      border: 1px solid #ddd;
      border-radius: 5px;
      background: #f9f9f9;
      color: #666;
      font-size: 13px;
      line-height: 1.6;
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
